<script>
export default {
  name: 'Tabs',
  inheritAttrs: false,
  props: {
    tabs: {
      type: [Boolean, Array],
      required: false
    },
    activeKey: [String, Number]
  },
  data() {
    return {
      active: undefined
    };
  },
  watch: {
    watch: {
      activeKey: {
        handler(val) {
          this.active = val;
          console.log('activeKey', this.active);
        },
        immediate: true
      }
    },
    active: {
      handler: function(val) {
        this.$emit('navActive', val);
      }
    }
  },
  methods: {
    renderTabs() {
      const panes = (tabs, result = []) => {
        for (const i in tabs) {
          const tab = tabs[i];
          result.push(
            <van-tab lazy-render={false} title={tab.title} name={tab.id}>
              {tab.component}
            </van-tab>
          );
        }
        return result;
      };
      const tabs = (
        <div class={'tabs-panel'}>
          <van-tabs v-model={this.active} {...{ props: this.$attrs, on: { ...this.$listeners } }}>
            {' '}
            {panes(this.tabs)}{' '}
          </van-tabs>
        </div>
      );
      return tabs;
    }
  },

  render() {
    return this.tabs ? this.renderTabs() : <div>哈哈哈</div>;
  }
};
</script>
